const LOG_PREFIX = '[safeStorage]';

const safeStorage = {
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.warn(`${LOG_PREFIX} localStorage.getItem("${key}") blocked:`, e.message);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`${LOG_PREFIX} localStorage.setItem("${key}") blocked:`, e.message);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.warn(`${LOG_PREFIX} localStorage.removeItem("${key}") blocked:`, e.message);
    }
  },
};

export const safeSessionStorage = {
  getItem: (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      console.warn(`${LOG_PREFIX} sessionStorage.getItem("${key}") blocked:`, e.message);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      console.warn(`${LOG_PREFIX} sessionStorage.setItem("${key}") blocked:`, e.message);
    }
  },
  removeItem: (key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {
      console.warn(`${LOG_PREFIX} sessionStorage.removeItem("${key}") blocked:`, e.message);
    }
  },
};

export default safeStorage;
